export default "__VITE_ASSET__d0a57fee__"